import React from "react";
import { twMerge } from "tailwind-merge";
export const Metric = ({ children, className, }) => {
    return (React.createElement("h3", { className: twMerge("onvo-text-3xl onvo-font-semibold onvo-text-slate-800 dark:onvo-text-slate-200", className || "") }, children));
};
export const Title = ({ children, className, onClick }) => {
    return (React.createElement("h3", { onClick: onClick, className: twMerge("onvo-text-lg onvo-font-semibold onvo-text-slate-800 dark:onvo-text-slate-200", className || "") }, children));
};
export const Label = ({ children, className, }) => {
    return (React.createElement("label", { className: twMerge("onvo-text-sm onvo-font-semibold onvo-text-slate-500 dark:onvo-text-slate-400", className || "") }, children));
};
export const Text = ({ children, className, style }) => {
    return (React.createElement("p", { style: style, className: twMerge("onvo-text-sm onvo-text-slate-500 dark:onvo-text-slate-400", className || "") }, children));
};
//# sourceMappingURL=Text.js.map